import { useStore } from '@/models'
import { GameScreen } from '@/screens/new-design'

export default function () {
  const {
    game: { setWalkthroughType }
  } = useStore()
  setWalkthroughType('RaiseOrFold')
  return <GameScreen />
}
